import { Loading } from '../../components/Loading';
import { useAuth } from '../../contexts/AuthContext';
import { useCurrentUser } from 'hooks';
import InquiryChatContent from './InquiryChatContent';

export default function InquiryChatPage() {
  const { user } = useAuth();
  const { data: currentUser, isLoading } = useCurrentUser();

  if (!user || isLoading || !currentUser?.uuid) {
    return (
      <>
        <div className="flex chat-section-h items-center justify-center">
          <Loading />
        </div>
      </>
    );
  }

  return (
    <>
      <InquiryChatContent />
    </>
  );
}
